import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { isUndef } from '@/lib/utils';
import { Component, Vue, Prop } from 'vue-property-decorator';
/**
 * @update(names, ids) 数据更新
 * @finish() 点击最后一级的情况下触发事件，可能使用于当点击最后一级的情况下，将关闭地址选择组件
 */

var Cascader =
/** @class */
function (_super) {
  __extends(Cascader, _super);

  function Cascader() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 当前显示的level */


    _this.level = 0;
    _this.itemMap = {};
    _this.listMap = {};
    return _this;
  }

  Object.defineProperty(Cascader.prototype, "list", {
    get: function get() {
      return this.level === 0 ? this.listMap[0] : this.listMap[this.value[this.level - 1]];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Cascader.prototype, "lastId", {
    /**
     * 如果没有的情况下，返回null
     *
     * @return {Number|null} 最后一级districtId，当没有districtIds时候返回null
     */
    get: function get() {
      var len = this.value.length;

      if (len === 0) {
        return null;
      }

      return this.value[len - 1];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Cascader.prototype, "moreColumnVisible", {
    /**
     * 指示下一列是否存在
     *
     * 1. 当前列数>=3的情况 -> false
     * 2. isUndef(lastDistrictId) -> true
     * 3. district的level达到标准的情况下 -> false
     * 4. !list == null && !(list.length === 0)
     */
    get: function get() {
      // 如果列数已经到达了3
      if (this.value.length >= this.maxLevel) {
        return false;
      } // 如果最后一个districtId不存在情况下，表明当前没有任何级别被选中


      var lastId = this.lastId; // 如果最后一级的list不存在，那么返回false

      if (isUndef(this.listMap[lastId]) || !this.listMap[lastId].length) {
        return false;
      }

      if (isUndef(lastId)) {
        return true;
      }

      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Cascader.prototype, "crumbs", {
    /**
     * 所需要显示的面包屑导航
     *
     * - 当没有的情况下，将会默认显示一列内容
     */
    get: function get() {
      var _this = this;

      if (this.value.length > 0) {
        var result = this.value.map(function (id) {
          var item = _this.itemMap[id];
          return item ? item.name : '';
        });

        if (this.moreColumnVisible) {
          result.push('请选择');
        }

        return result;
      } else {
        return ['请选择'];
      }
    },
    enumerable: false,
    configurable: true
  });

  Cascader.prototype.innerFetchList = function (item) {
    return __awaiter(this, void 0, void 0, function () {
      var ret, i, len;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.fetchList(item)];

          case 1:
            ret = _a.sent();

            for (i = 0, len = ret.length; i < len; i++) {
              this.$set(this.itemMap, ret[i].id, ret[i]);
            }

            this.$set(this.listMap, item.id, ret);
            this.$emit('itemMap', this.itemMap);
            this.$emit('listMap', this.listMap);
            return [2
            /*return*/
            , ret];
        }
      });
    });
  };
  /**
   * 当address被点击
   *
   * @param {} id 行政区id
   * @param {} column 列数，从0开始
   */


  Cascader.prototype.onClickItem = function (item, level) {
    return __awaiter(this, void 0, void 0, function () {
      var ids, list;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            ids = this.value.slice(0, level); // 更新ids

            ids.push(item.id);
            return [4
            /*yield*/
            , this.innerFetchList(item)];

          case 1:
            list = _a.sent();

            if (list.length > 0) {
              this.level = level + 1;
            }

            this.$emit('input', ids);
            this.$nextTick(function () {
              if (!_this.moreColumnVisible) {
                _this.$emit('finish');
              }
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 点击面包屑的时候
   *
   * @param {} index 导航的位置
   */


  Cascader.prototype.onClickCrumb = function (level) {
    this.level = level;
  };

  Cascader.prototype.created = function () {
    this.innerFetchList({
      id: 0,
      name: ''
    });

    if (this.value && this.value.length) {
      for (var i = 0, len = this.value.length; i < len; i++) {
        this.innerFetchList({
          id: this.value[i],
          name: ''
        });
      }
    }
  };

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], Cascader.prototype, "value", void 0);

  __decorate([Prop({
    type: Number,
    "default": 3
  })], Cascader.prototype, "maxLevel", void 0);

  __decorate([Prop({
    required: true,
    type: Function
  })], Cascader.prototype, "fetchList", void 0);

  __decorate([Prop({
    type: String
  })], Cascader.prototype, "color", void 0);

  Cascader = __decorate([Component({
    name: 'Cascader'
  })], Cascader);
  return Cascader;
}(Vue);

export default Cascader;